import { VERSION } from '../version';
export function registerInitialMetas(faro) {
    var _a;
    const initial = {
        sdk: {
            name: '@grafana/faro-core',
            version: VERSION,
            integrations: faro.config.instrumentations.map(({ name, version }) => ({ name, version })),
        },
    };
    if (faro.config.session) {
        faro.api.setSession(faro.config.session);
    }
    if (faro.config.app) {
        initial.app = faro.config.app;
    }
    if (faro.config.user) {
        initial.user = faro.config.user;
    }
    if (faro.config.view) {
        initial.view = faro.config.view;
    }
    faro.metas.add(initial, ...((_a = faro.config.metas) !== null && _a !== void 0 ? _a : []));
}
//# sourceMappingURL=registerInitial.js.map